import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-postalcode-nfdialog',
  templateUrl: './postalcode-nfdialog.component.html',
  styleUrls: ['./postalcode-nfdialog.component.css']
})
export class PostalcodeNFDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
